import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

class SiteConfigApi {
  updateEmailSiteConfig(data) {
    return axios.post(`${baseUrl}/siteConfig/email`, data)
  }
  getSiteConfig() {
    return axios.get(`${baseUrl}/siteConfig`)
  }
}

export default new SiteConfigApi()
